module.exports = __webpack_public_path__ + "img/DynamoDB-Partitions-Example.fe2230ab.png";